import React from 'react'

function DashboardContact() {
  return <>
  <div>Bu Sayfa Private Contact Sayfası
    
  </div>
  </>
}

export default DashboardContact